import { axios } from 'api'

const deleteUserCache = (orderNumber: string, company: string) =>
  axios
    .get(`/cache/delete-user-cache`, {
      params: {
        orderNumber,
        company
      }
    })
    .catch(err => {
      console.error(err)
    })

export { deleteUserCache }
